import './App.less';
import ContactUs from './Model/ConatctUs';
import Description from './Model/Description';
import Footer from './Model/Footer';
import Header from './Model/Header';
import Testimonials from './Model/Testimonials';
import logo from './logo.jpeg'
import { useNavigate } from 'react-router-dom';
import ImageShow from './Model/ImageShow';

function AboutUs() {

  const navigate = useNavigate();
  const headerConfig = {
    logo,
    brand: 'Aspire Homes',
    menuItems: [
      {
        type: 'link',
        name: 'Home',
        link: '/',
        onClick: () => {

          navigate("/")
        }
      },
      {
        type: 'link',
        name: 'About',
        link: '#about',
        onClick: () => {
          const el = document.getElementsByClassName('description-section')[0];
          if (el) el.scrollIntoView({ behavior: 'smooth' });
        }
      },
      {
        type: 'link',
        name: 'Service',
        link: '#why',
        onClick: () => {
          const el = document.getElementsByClassName('gallery-section')[0];
          if (el) el.scrollIntoView({ behavior: 'smooth' });
        }
      },
      {
        type: 'link',
        name: 'Gallery',
        link: '/gallery',  // navigate to a separate route
        onClick: () => {
          const el = document.getElementsByClassName('gallery-section')[0];
          if (el) el.scrollIntoView({ behavior: 'smooth' });
        }
      },
      {
        type: 'link',
        name: 'Contact',
        link: '#contact',
        onClick: () => {
          const el = document.getElementsByClassName('contact-section')[0];
          if (el) el.scrollIntoView({ behavior: 'smooth' });
        }
      }
    ]
  };



  return (
    <>
      <Header {...headerConfig} />
      <ImageShow  image="/images/app/contact.png" title=" " />
      <Description />
      <Testimonials id="testimonials" />
      <ContactUs id="contact" />
      <Footer />
    </>
  );
}

export default AboutUs;
